export const SEQUENCE_NUMBER = {
  "Sequencenumber.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Sequencenumber.Color": {
    ref: "Input.Color"
  },
  "Sequencenumber.Font.Weight": {
    ref: "Input.Font.Weight"
  },
  "Sequencenumber.Line.Height": {
    ref: "Input.Line.Height"
  },
  "Sequencenumber.Letter.Spacing": {
    ref: "Input.Letter.Spacing"
  },
  "Sequencenumber.Bg.Color": {
    ref: "Input.Readonly.Bg.Color"
  },
  "Sequencenumber.Border.Color": {
    ref: "Input.Readonly.Border.Color"
  },
  "Sequencenumber.Border.Top.Width": {
    ref: "Input.Readonly.Border.Top.Width"
  },
  "Sequencenumber.Border.Bottom.Width": {
    ref: "Input.Readonly.Border.Bottom.Width"
  },
  "Sequencenumber.Border.Left.Width": {
    ref: "Input.Readonly.Border.Left.Width"
  },
  "Sequencenumber.Border.Right.Width": {
    ref: "Input.Readonly.Border.Right.Width"
  },
  "Sequencenumber.Shadow": {
    ref: "Input.Readonly.Shadow"
  },
  "Sequencenumber.Border.Top.Left.Radius": {
    ref: "Input.Border.Top.Left.Radius"
  },
  "Sequencenumber.Border.Top.Right.Radius": {
    ref: "Input.Border.Top.Right.Radius"
  },
  "Sequencenumber.Border.Bottom.Left.Radius": {
    ref: "Input.Border.Bottom.Left.Radius"
  },
  "Sequencenumber.Border.Bottom.Right.Radius": {
    ref: "Input.Border.Bottom.Right.Radius"
  },
  "Sequencenumber.Padding.Top": {
    ref: "Input.Padding.Top"
  },
  "Sequencenumber.Padding.Bottom": {
    ref: "Input.Padding.Bottom"
  },
  "Sequencenumber.Padding.Left": {
    ref: "Input.Padding.Left"
  },
  "Sequencenumber.Padding.Right": {
    ref: "Input.Padding.Right"
  }
};
